$(document).ready(function () {
    const customProduct = {
        moneyFormatNoDecimals: '\$\{\{amount_no_decimals\}\}',
        galleryThumbsOptions: function (){
            return {
                spaceBetween: 17,
                slidesPerView: 'auto',
                direction: 'vertical',
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            }
        },
        galleryTopOptions: function(galleryThumbs){
            return {
                spaceBetween: 0,
                thumbs: {
                    swiper: galleryThumbs
                }
            }
        },
        accordionInit: function (){
            // product custom - accordion
            $('.accordion-item .accordion-heading').click(function () {
                $(this).parent().toggleClass('accordion-opened');
            });
        },
        popupInit: function (){
            $('#product-custom-popup .close').click(function () {
                $('#product-custom-popup').hide();
            });
            $('.open-popup-text').click(function () {
                $('#product-custom-popup').show();
            });
        },
        tabActions: function (){
            $('.button-next-tab').click(function () {
                $('.tab-content-item, .tab-item').removeClass('active');
                $('div[tab-name="summary-tab"]').addClass('active');
                $( ".subscribe-plan.active .checkbox").prop('checked', true);  
                $( ".subscribe-plan:not(.active) .checkbox").prop('checked', false);
                let tabsOffsetTop = document.getElementById('product-tabs-anchor').offsetTop;
                tabsOffsetTop = tabsOffsetTop - 25;
                $('body,html').animate({scrollTop: tabsOffsetTop}, 600);

                $('.btn.button').text('Add to cart');
            });

            $('.tab-item').click(function () {
                $('.tab-content-item, .tab-item').removeClass('active');
                let tabName = $(this).attr('tab-name');
                $('div[tab-name="' + tabName + '"]').addClass('active');
            });
        },

        /**
         * Remove all items in the cart
         * @param callback {function}
         */
        clearCart: function (callback){
//             $.ajax({
//                 type: "POST",
//                 url: '/cart/clear.js',
//                 success: function(){
//                     callback();
//                 },
//                 dataType: 'json'
//             });
          console.log("clearCart isn't implemented");
          callback();
        },

        /**
         * getCollectionProducts
         * @param collectionHandle {string}
         * @returns {Promise<object>}
         */
        getCollectionProducts: function (collectionHandle){
            return new Promise(function(resolve, reject){
                try {
                    $.getJSON('/collections/' + collectionHandle + '/products.json', resolve);
                }catch (e){
                    reject(e);
                }
            });
        },

        /**
         * updateGallery
         * @param sliderImages {object}
         * @param galleryThumbs {Swiper}
         * @param galleryTop {Swiper}
         */
        updateGallery: function (sliderImages, galleryThumbs, galleryTop){
            if( sliderImages.length > 1 ){
                galleryThumbs.removeAllSlides();
                galleryTop.removeAllSlides();
                for (let index in sliderImages) {
                    if(index > 2 ){
                        galleryThumbs.addSlide(index, '<div class="swiper-slide product-thumb-slide"><img src="'+sliderImages[index].src+'"></div>');
                        galleryTop.addSlide(index, '<div class="swiper-slide product-media-slide"><img src="'+sliderImages[index].src+'"></div>');
                    }
                }
            }else{
                galleryThumbs.removeAllSlides();
                galleryTop.removeAllSlides();
            }
        },

        getPricePerBottle: function(totalPrice, bottlesQty){
            return window.theme.Currency.formatMoney(Number(totalPrice) / Number(bottlesQty), this.moneyFormatNoDecimals);
        },

        /**
         * Update Shade Tab
         * @param activeProducts
         * @param products
         */
        updateShadeTab: function (activeProducts, products){
            $('.product-item').removeClass('active');
            if( activeProducts.length !== 0 ){
                for (let index in activeProducts) {
                    activeProducts[index].activeItem.addClass('active');
                    activeProducts[index].activeItem.find('.active-variant-value').text(activeProducts[index].bottlesQty);
                    activeProducts[index].activeItem.find('.per-bottle-value').text(
                        this.getPricePerBottle(activeProducts[index].price, activeProducts[index].bottlesQty)
                    );
                    $('.tab-subtext').html(products[activeProducts[index].index].body_html);
                    $('.button-next-tab').removeClass('disabled');
                }
            }else{
                $('.button-next-tab').addClass('disabled');
            }
        },

        selectProductTemplate: function (product, qty, price){
            return '<div class="selected-product">'+
                '<img src="'+ product.images[0].src +'" alt="'+ product.title +'" class="product-item-image">'+
                '<div class="product-title align--center product-title-value">'+ product.title +'</div>'+
                '<div class="active-variant">'+
                '<div><span class="active-variant-value">'+ qty +'</span> Bottles</div>'+
                '<span class="per-bottle"><span class="per-bottle-value">'+ this.getPricePerBottle(price, qty) +'</span> per bottle </span>'+
                '</div>'+
                '</div>';
        },

        updateSummaryTab: function (activeProducts, products){
            let bottlesQty = 0;
            let totalPrice = 0;
            $('#selected-products').html('');
            let activeProductsHTML = '';
            for (let product of activeProducts) {

                activeProductsHTML += this.selectProductTemplate(products[product.index], product.bottlesQty, product.price);
                bottlesQty += Number(product.bottlesQty);
                totalPrice += Number(product.price);
            }
            $('#selected-products').html(activeProductsHTML);
            $('.bottles-value').text(bottlesQty);
            $('.price-per-bottle-value').text(window.theme.Currency.formatMoney(totalPrice, this.moneyFormatNoDecimals));
        },

        changeShadeHandler: function (galleryThumbs, galleryTop){
            const _this = this;
            const activeProducts = [];
            this.customAddToCart(activeProducts);
            this.getCollectionProducts('bundle').then(function (collectionProducts){
                $('.products-list').removeClass('disabled');
                const products = collectionProducts.products;
                if( products.length > 0 ){

                    // remove item
                    $('.disable-variant').click( function (){
                        let index = $(this).attr('index');
                        let findIndex = activeProducts.findIndex(function (product){
                            return product.index == index;
                        });
                        if(findIndex >= 0 ){
                            activeProducts.splice(findIndex, 1);
                            _this.updateShadeTab(activeProducts, products);
                            _this.updateSummaryTab(activeProducts, products);
                        }
                    });

                    // add item
                    $('.variant-item').click(function (){
                        let index = $(this).attr('index');
                        let productData = {
                            index: index,
                            activeItem: $('.product-item[index="'+index+'"]'),
                            variantId: $(this).attr('variant-id'),
                            bottlesQty: $(this).attr('variant-title'),
                            price: $(this).attr('variant-price'),
                        };
                        let findProductIndex = activeProducts.findIndex(function (product){
                            return product.index == index;
                        });
                        if( findProductIndex < 0 ){
                            activeProducts.push(productData);
                        }else{
                            activeProducts.splice(findProductIndex, 1, productData);
                        }
                        const sliderImages = products[productData.index].images;
                        _this.updateGallery(sliderImages, galleryThumbs, galleryTop);
                        _this.updateShadeTab(activeProducts, products);
                        _this.updateSummaryTab(activeProducts, products);
                        _this.updateIngredients(products[productData.index].handle);
                    });
                }
            });
        },
      
      initSliderScheduler: function() {
      
      },

        updateIngredients: function (productHandle){
            console.log(productHandle);
            $('.ingredients-content').removeClass('active');
            $('.ingredients-content.'+ productHandle).addClass('active');
        },

        customAddToCart: function (activeProducts){
            $('#custom-add-button').click((function (){
                this.clearCart(function (){
                    let data = { items: [] };
                    for (let activeProduct of activeProducts) {
                        data.items.push({
                            quantity: 1,
                            id: activeProduct.variantId
                        });
                    }
                    $.post('/cart/add.js', data, null, "json").done(function(){
                        window.location = "/checkout/";
                    }).fail(function(error) {
                        console.log(error.status);
                    });
                });
            }).bind(this));
        },

        customSubscribeTemplate: {
            init: function (){
                this.changePlan();
                this.addOneTimeProduct();
              	this.addYearlyProduct();
              console.log("init customSubscribeTemplate");
            },
            changePlan: function (){
              $('.custom-subscribe-box-double .subscribe-plan').each(function() {
                $(this).bind("click", function (evt){
                    $('.custom-subscribe-box-double .subscribe-plan').removeClass('active');
                    $(this).addClass('active');
                    var _select_product = $(this).find('input.select-product');
                    _select_product.prop('checked', true);
                    $('.subscribe-review-wrap .product-price').text(_select_product.data('total-price-money'));

                    var review_total_price = _select_product.data('total-price');
                    if(_select_product.data('plan') != 2){
                        $('.checkbox-addons.extras:checked').each(function(){
                            var qty = $('#Addons-Quantity-' + $(this).val()).val();
                            review_total_price += $(this).data('price') * qty;
                        });
                    }
                    $('.subscribe-review-wrap .total-price').text('$' + (review_total_price/100));
                    
                    let planValue = $(this).attr('plan-value');
                    //console.log('planValue',planValue);
                    if(planValue == 0){
                        $('.review-title').text('One-Time Product');
                    } else {
                        $('.review-title').text('Subscription Product');
                    }
                    /*if(planValue == 2){
                        $('.nav-extras').hide();
                        $('.nav-review span').text('4');
                        $('.extra-product').hide();
                    } else {
                        $('.nav-extras').show();
                        $('.nav-review span').text('5');
                        $('.extra-product').show();
                    }*/
                    /*if(planValue == 0){
                        $('.btn.add-subscribe').hide();
                        $('.add-one-time').show();
                        $('.btn.add-yearly').hide();
                    }
                    else if(planValue == 1){
                      	$('.btn.add-subscribe').show();
                        $('.add-one-time').hide();
                        $('.btn.add-yearly').hide();
                    }
                    else if(planValue == 2){
                      	$('.btn.add-subscribe').hide();
                        $('.add-one-time').hide();
                        $('.btn.add-yearly').show();
                    }
                    else {
                        throw new Error("Unsupported subscription plan value: " + planValue);
                    }*/
                });
              });

            },
            addOneTimeProduct: function() {
                const buttonOneTime = $('#add-one-time');
                buttonOneTime.click((function (){
                    customProduct.clearCart(function (){
                        console.log('addToCart');
                        let data = { items: [] };
                        let productId = buttonOneTime.attr('product-id');
                        data.items.push({
                            quantity: 1,
                            id: productId
                        });
                        buttonOneTime.text('Adding...');
                        $.post('/cart/add.js', data, null, "json").done(function(){
                            buttonOneTime.text('Thank you!');
                            window.location = "/cart/";
                        }).fail(function(error) {
                            console.log(error.status);
                        });
                    });
                }).bind(this));
            },
          addYearlyProduct: function() {
			console.log("Yearly submit is activated.");
            const yearlySubscriptionGroupId = 170160; // Hardcoded yearly subscription
            const prepaidLength = 2;
            
            $(".add-yearly").bind("click", function() {
              // Add new inputs to the existed product form
              
              const form = document.querySelector(".shopify-product-form");
              let elements = [...form.elements].filter(e => ["INPUT", "SELECT"].includes(e.tagName) );
              let input_ID = elements.find(e => e.getAttribute("name") === "id");
              let product_id = elements.find(e => e.getAttribute("name") === "product_id[]");
              let variant_id = elements.find(e => e.getAttribute("name") === "variant_id[]");
              let discounted_price = elements.find(e => e.getAttribute("name") === "properties[discounted_price]");
              let discount_percentage = elements.find(e => e.getAttribute("name") === "properties[_ro_discount_percentage]");
              let ro_unformatted_price = elements.find(e => e.getAttribute("name") === "properties[_ro_unformatted_price]");
              let group_id = elements.find(e => e.getAttribute("name") === "properties[group_id]");
              let quantities = elements.find(e => e.getAttribute("name") === "quantities[]");
              let frequencies_num = elements.find(e => e.getAttribute("name") === "properties[frequency_num]");
			  let frequencies_type = elements.find(e => e.getAttribute("name") === "properties[frequency_type]");
              let frequencies_text = elements.find(e => e.getAttribute("name") === "properties[frequency_type_text]");
              
              
              // Get recurring prepaid length id and submit the form
              console.debug("Get subscription group id");
              $.get(`https://ro.boldapps.net/api/widget/group/${yearlySubscriptionGroupId}?shop=true-sons-tl.myshopify.com`)
              	.then(function(data){
                	// Replace form's action url
                    $(form).attr("action", "https://recurringcheckout.com/s/true-sons-tl/checkout/recurring_product?shop_url=true-sons-tl.myshopify.com");
                	// Replace existed input values
                    product_id.value = yearly.id;
                    input_ID.value = yearly.variants[0].id;
                    variant_id.value = yearly.variants[0].id;
                    ro_unformatted_price.value = yearly.variants[0].price;
                    discounted_price.value = "$" + (yearly.variants[0].price / 100);
                    group_id.value = yearlySubscriptionGroupId;
                    quantities.value = 1;
                    frequencies_num.value = 3;
                    frequencies_type.value = 3;
                    frequencies_text.value = 'Month';
                    const prepaidLengthId = data.prepaid.lengths
                          .find(value => value.length == prepaidLength)
                          .id;
                	// Append missed inputs
                    $(form).append(`
                      <div class="bold-ro__prepaid-container">
                          <input type="hidden" name="is_prepaid" value="1">
                          <input type="hidden" name="prepaid_length_id" value="${prepaidLengthId}">
                          <input type="hidden" name="total_recurrences" value="${prepaidLength}">

                          <input type="hidden" name="discounted_price" value="${discounted_price.value}">
                          <input type="hidden" name="_ro_discount_percentage" value="${discount_percentage.value}">
                          <input type="hidden" name="_ro_unformatted_price" value="${ro_unformatted_price.value}">
                          <input type="hidden" name="group_id" value="${group_id.value}">
                          <input type="hidden" name="frequency_num" value="${frequencies_num.value}">
                          <input type="hidden" name="frequency_type" value="${frequencies_type.value}">
                          <input type="hidden" name="frequency_type_text" value="${frequencies_text.value}">
                      </div>
                    `);
                 	form.submit();
              });
              
            });
          }
        },


        init: function (){ 
            this.accordionInit();
            this.popupInit();
//             this.tabActions();
            const galleryThumbs = new Swiper('#custom-product-thumbs', this.galleryThumbsOptions());
            const galleryTop = new Swiper('#custom-product-gallery', this.galleryTopOptions(galleryThumbs));
            this.changeShadeHandler(galleryThumbs, galleryTop);
            this.customSubscribeTemplate.init(); 
        }
    }
    customProduct.init();
 

  if(performance.navigation.type == 2){
    location.reload(true);
  }

  
//   if (window.location.pathname.indexOf("/products/get-started-true-black") == 0) {
//     jQuery('.my_modal').show();
//     jQuery('.my_modal-bg').show();
//     jQuery('.my_modal .close').click(function () {
//       jQuery('.my_modal').hide();
//       jQuery('.my_modal-bg').hide();
//     }); 
//   }   

//   if (window.location.pathname.indexOf("/products/get-started-light-brown") == 0) {
//     jQuery('.my_modal_lb').show();
//     jQuery('.my_modal-bg').show();
//     jQuery('.my_modal_lb .close').click(function () {
//       jQuery('.my_modal_lb').hide();
//       jQuery('.my_modal-bg').hide();

//     });
//   }
  
}); 
